<template>
  <div class="change-password-dialog">
    <el-dialog append-to-body :title="dialogName" :visible="isShow" :close-on-click-modal="false" @close="closeDialog" width="600px">
      <el-form class="form" :model="vForm" :rules="rules" ref="vForm" label-width="80px" auto-complete="off" size-medium>
        <el-form-item label="排序" class="form-group" prop="sort">
          <el-input type="text" class="form-control" v-model="vForm.sort" placeholder="数字越大排序越靠前" />
        </el-form-item>
        <el-form-item label="方法名称" class="form-group" prop="title">
          <el-input type="text" class="form-control" v-model="vForm.title" />
        </el-form-item>
        <el-form-item label="接口地址" class="form-group" prop="path">
          <el-input type="text" class="form-control" v-model="vForm.path" placeholder="如：/user/info" />
        </el-form-item>
        <el-form-item label="节点归属" class="form-group">
          <el-radio v-model="vForm.origin_type" :label="2" :disabled="!(addEditType == 1 && !row)">SaaS</el-radio>
          <el-radio v-model="vForm.origin_type" :label="1" :disabled="!(addEditType == 1 && !row)">平台</el-radio>
        </el-form-item>
        <el-form-item label="状态" class="form-group" prop="hidden">
          <el-radio v-model="vForm.is_show" :label="1">启用</el-radio>
          <el-radio v-model="vForm.is_show" :label="0">禁用</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog" size="small">取 消</el-button>
        <el-button type="primary" @click="doSubmit" :loading="doSubmitLoading" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['isShow', 'addEditType', 'row'],
  data() {
    return {
      doSubmitLoading: false,
      dialogName: '',
      vForm: {
        sort: '10000',
        title: '',
        path: '',
        is_show: 1,
        pid: 0,
        origin_type: 2,
        type: 2,
      },
      rules: {
        sort: { required: true, message: '排序必填', trigger: 'blur' },
        title: { required: true, message: '方法名称必填', trigger: 'blur' },
        path: { required: true, message: '接口地址必填', trigger: 'blur' },
      },
    };
  },
  created() {
    if (this.addEditType == 1) {
      this.dialogName = '添加节点';
    }
    if (this.addEditType == 2) {
      this.dialogName = '修改节点';
      this.$nextTick(() => {
        Object.assign(this.vForm, this.row);
      });
    }
    if (this.addEditType == 3) {
      this.dialogName = '添加子节点';
      this.$nextTick(() => {
        Object.assign(this.vForm, { pid: this.row.id });
      });
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:isShow', false);
    },
    doSubmit() {
      this.$refs.vForm.validate(async (valid) => {
        if (valid) {
          this.doSubmitLoading = true;
          try {
            let res = null;
            if (this.addEditType == 1 || this.addEditType == 3) {
              res = await this.api.userAdmin.addPermission(this.vForm);
            } else {
              res = await this.api.userAdmin.editPermission(this.vForm);
            }
            this.$message.success(res.message);
            this.doSubmitLoading = false;
            this.closeDialog();
            this.$emit('success');
          } catch (ex) {
            this.doSubmitLoading = false;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
